import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import { SectionModel } from 'entities/section/model/sectionModel';
import TrashPageHeader from 'pages/trash/trashPageHeader';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TrashContentGridController from 'widgets/grids/trashContentGridController';
import FinallyDeleteSectionModalController from 'widgets/sections/finallyDeleteSectionModalController';
import RestoreSectionModalController from 'widgets/sections/restoreSectionModalController';

export default observer(function TrashExplorerSection({
  sectionModel,
}: {
  sectionModel: SectionModel;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isRestore, setIsRestore] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  return sectionModel?.data ? (
    <>
      <PageInnerContainer>
        <TrashPageHeader
          text={sectionModel.name || ''}
          clearText="Удалить"
          restoreText={t('common.restore')}
          onRestore={() => setIsRestore(true)}
          onClear={() => setIsDelete(true)}
        ></TrashPageHeader>

        <TrashContentGridController
          items={sectionModel.content}
          sort={{ key: sectionModel.sortKey, order: sectionModel.sortOrder }}
          onSortChange={(val) => {
            sectionModel.sortKey = val.key;
            sectionModel.sortOrder = val.order;
            sectionModel.getContent({ in_trash: null });
          }}
          afterFileDelete={(id) => {
            sectionModel.localDeleteFile(id);
          }}
          afterFileRestore={(item) => {
            sectionModel.localDeleteFile(item.id);
          }}
          afterTableRestore={(item) => {
            sectionModel.localDeleteTable(item.id);
          }}
          afterTableDelete={(id) => {
            sectionModel.localDeleteTable(id);
          }}
          afterFolderRestore={(data) => {
            sectionModel.localDeleteFolders([data.id]);
          }}
          afterFolderFinallyDelete={(id) => {
            sectionModel.localDeleteFolders([id]);
          }}
        ></TrashContentGridController>

        {isRestore && (
          <RestoreSectionModalController
            section={sectionModel.data}
            handleClose={() => setIsRestore(false)}
            afterSectionRestore={() => navigate('/trash')}
          ></RestoreSectionModalController>
        )}

        {isDelete && (
          <FinallyDeleteSectionModalController
            id={sectionModel.id}
            handleClose={() => setIsDelete(false)}
            afterSectionFinallyDelete={() => {
              navigate('/trash');
            }}
          ></FinallyDeleteSectionModalController>
        )}
      </PageInnerContainer>
    </>
  ) : (
    <></>
  );
});
